export const config = {
  title: 'BA Cleaning Services LLC',
  meta: {
    description:
      'BA Cleaning Services LLC offers premium residential and commercial cleaning services in Orting, WA, ensuring your space is spotless and inviting.',
    keywords: [
      'Cleaning Services',
      'Residential Cleaning',
      'Commercial Cleaning',
      'Standard Cleaning',
      'Deep Cleaning',
      'Move-In Cleaning',
      'Move-Out Cleaning',
      'Post-Construction Cleaning',
      'Orting WA',
      'BA Cleaning Services LLC',
    ],
    author: 'BA Cleaning Services LLC',
    canonicalUrl: 'https://bacleanings.com/',
  },
  sections: {
    header: {
      businessName: 'BA Cleaning Services LLC',
    },
    sectionB: {
      heroTitle: 'BA Cleaning Services LLC',
      heroSubtitle: 'Premium Cleaning Services in Orting, WA',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '+12066194136',
      phoneLabel: '(206) 619-4136',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1194628093/photo/female-hand-set-up-white-bed-sheet-in-bedroom.jpg?s=612x612&w=0&k=20&c=OP2w-C1SqhI0ln6pyyuJq4O2TAR8vhPxiGVTaZOvWRU=',
      cardData: [
        {
          title: 'Standard Cleaning',
          description:
            'Maintain a consistently clean home with our regular cleaning services, tailored to your schedule and needs.',
        },
        {
          title: 'Deep Cleaning',
          description:
            'Our deep cleaning services ensure every corner of your home is spotless, providing a thorough and detailed clean.',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Ensure a smooth transition with our comprehensive move-in and move-out cleaning services, leaving your space immaculate.',
        },
      ],
      description:
        'At BA Cleaning Services LLC, we provide a range of cleaning solutions, including standard cleaning, deep cleaning, move-in/move-out cleaning, and post-construction cleaning, all designed to keep your space pristine.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Discover our comprehensive cleaning services designed to meet your residential and commercial needs.',
      cards: [
        {
          title: 'Standard Cleaning',
          description:
            'Regular cleaning services to keep your home consistently clean and comfortable.',
          imageSrc: 'https://media.istockphoto.com/id/1363376671/photo/young-woman-holding-a-floor-wiper-and-wiping-floor-keeping-the-daily-home-hygiene-and-doing.jpg?s=612x612&w=0&k=20&c=5xL84gR6KA0Sj3Gk1MM0Of07zhgkb0WTzhq8A_I7ulk=',
          imageAlt: 'Standard Cleaning',
        },
        {
          title: 'Deep Cleaning',
          description:
            'Thorough cleaning services targeting every nook and cranny for a spotless home.',
          imageSrc: 'https://media.istockphoto.com/id/1297677804/photo/housemaid-cleans-the-table-mop-and-blue-bucket-with-the-detergents-in-the-background.jpg?s=612x612&w=0&k=20&c=RF_e5FgbMRzTRXYJtDMvKa0IsAmbsGkVYST7HkpFL4M=',
          imageAlt: 'Deep Cleaning',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Comprehensive cleaning services to ensure your new or old home is immaculate during transitions.',
          imageSrc: 'https://media.istockphoto.com/id/915613234/photo/young-woman-cleaning-wooden-floor-in-new-apartment.jpg?s=612x612&w=0&k=20&c=aKI_YY6YOjrvyhJDf6LSHvvTedx8mdsKyStcN5nMOb0=',
          imageAlt: 'Move-In/Move-Out Cleaning',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Post-Construction Cleaning',
        'Commercial Cleaning',
        'Customized Cleaning Plans',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=362,fit=crop,q=95/mP42Wg7r1ZhWOqQ0/pink-hands-logo-1-copy-17-AE0aJXX5rvCXyz8k.png',
        alt: 'BA Cleaning Services LLC Team',
      },
      aboutText: [
        'BA Cleaning Services LLC is a premier cleaning company based in Orting, WA, dedicated to providing top-notch cleaning solutions for both residential and commercial clients.',
        'Our team of skilled professionals is committed to excellence, ensuring every space we clean is left spotless and inviting.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'BA Cleaning Services LLC Logo',
      businessName: 'BA Cleaning Services LLC',
      contact: {
        phone: '+12066194136',
        phoneLabel: '(206) 619-4136',
        email: 'bacleaning86@gmail.com',
        website: 'https://bacleanings.com/',
        address: '1202 Sigafoos Ave NW, Orting, WA',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/people/BA-Cleaning-Services-LLC/61572776857289/?mibextid=wwXIfr&rdid=jeOigHSPnD5VpI92&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1B5AAb99q9%2F%3Fmibextid%3DwwXIfr',
        instagram: 'https://www.instagram.com/ba_cleaning_/?igsh=MWduczl0dTk3ZGthMw%3D%3D&utm_source=qr#',
      },
    },
    sectionF: {
      address: '1202 Sigafoos Ave NW, Orting, WA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2689.123456789012!2d-122.1234567!3d47.0834567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8831234567890123%3A0xabcdef1234567890!2s1202%20Sigafoos%20Ave%20NW%2C%20Orting%2C%20WA!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
